/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import Base from './Sparklines.js';
import Line from './Line.js';
import Bar from './Bar.js';
import Curve from './Curve.js';
import Pie from './Pie.js';
import Gradient from './Gradient.js';
import { withInstall } from './withInstall.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/slicedToArray';
import 'vue';
import './props.js';
import './utils/uid.js';
import './constant.js';
import './utils/debounce.js';
import './Spot.js';
import './RefLine.js';
import './_chunks/dep-680ea5a1.js';
import './utils/min.js';
import './utils/max.js';
import './utils/mean.js';
import './utils/midRange.js';
import './utils/median.js';
import './utils/stdev.js';
import './utils/variance.js';
import './utils/dataToPoints.js';
import './utils/genColor.js';
import './utils/isEmpty.js';
import './hooks/useSpotCheck.js';
import './Text.js';
import './hooks/useStyles.js';
import '@babel/runtime/helpers/typeof';

var Sparklines = withInstall(Base);
var SparklineLine = withInstall(Line);
var SparklineBar = withInstall(Bar);
var SparklineCurve = withInstall(Curve);
var SparklinePie = withInstall(Pie);
var SparklineGradient = withInstall(Gradient);
var index = {
  install: function install(app) {
    app.use(Sparklines);
    app.use(SparklineLine);
    app.use(SparklineBar);
    app.use(SparklineCurve);
    app.use(SparklinePie);
    app.use(SparklineGradient);
  },
  version: "2.0.1"
};

export { SparklineBar, SparklineCurve, SparklineGradient, SparklineLine, SparklinePie, Sparklines, index as default };
//# sourceMappingURL=index.js.map
